<template>
    <div id="header" :class="{hasMobileMenu:showMobileMenu}">
        <div class="main-header">

            <div class="container">

                <div class="header-left-side">
                    <button class="btn px-0 sidebar-toggle-button" @click="toggleMobileMenu()">
                        <img src="/images/nav-icon.svg" alt="Navigation trigger" v-if="!itr && !peppr"/>
                        <img src="/images/itr/burgerwhite.png" alt="Navigation trigger" v-if="itr || peppr"/>
                    </button>

                    <language-selection screen="desktop" class="d-none d-lg-block"></language-selection>
                </div>

                <a :href="regionRelativeUrl('/')" id="logo">
                    <div class="header-logo">
                        <span class="vip-tag" v-if="isVipPunter">vip</span>
                    </div>
                </a>

                <div class="header-right-side">

                    <div class="header-auth-buttons" v-if="!currentUser">
                        <a :href="regionRelativeUrl('/users/registration/')"
                           class="btn btn-outline-primary my-1 btn-register mr-sm-0">
                            <span class="d-none d-sm-block">{{ translate.home.registerForFreeButton }}</span>
                            <span class="d-block d-sm-none">{{ translate.home.registerForFreeButtonMobile }}</span>
                        </a>

                        <a :href="regionRelativeUrl('/users/login/')"
                           class="black-link mx-3 mx-md-2 mx-lg-3 d-none d-sm-inline-block btn-nav-login">
                            {{ translate.login.login }}
                        </a>
                    </div>

                    <a v-if="currentUser && (isEscort || isVenue) && !isGoldUser(this.currentUser)"
                       :href="regionRelativeUrl('/users/products/buy-premium')"
                       @click="trackUpgradeClick('navbar_upgrade_gold')"
                       class="btn btn-outline-primary btn-register btn-mr btn-upgrade-gold">
                        <span class="d-none d-sm-block">{{ translate.product.upgradeGoldDesktop }}</span>
                        <span class="d-block d-sm-none">{{ translate.product.upgradeGold }}</span>
                    </a>

                    <a v-if="currentUser && isPunter && !isVipPunter"
                       :href="regionRelativeUrl('/users/products/punter-vip')"
                       @click="trackUpgradeClick('navbar_upgrade_vip')"
                       class="btn btn-outline-primary btn-register btn-mr btn-upgrade-vip">
                        <span class="d-none d-sm-block">{{ translate.product.upgradeVipDesktop }}</span>
                        <span class="d-block d-sm-none">{{ translate.product.upgradeVip }}</span>
                    </a>

                    <language-selection screen="mobile" class="d-block d-lg-none"></language-selection>

                    <a v-if="(!showMobileMenu) && currentUser && (isEscort || isVenue || isPunter)"
                       class="btn px-0 message-dropdown-button" :class="{'logged-in':currentUser}"
                       :href="regionRelativeUrl('/users/account/messages')">
                        <icon-component width="2em" :icon="fa_comments_alt()"></icon-component>
                        <div class="notification-counter" v-if="conversationUnreadMessageCount">
                            {{ conversationUnreadMessageCount }}
                        </div>
                    </a>

                    <div class="dropdown">
                        <a v-if="!showMobileMenu"
                           class="btn px-0 user-dropdown-button" :class="{'logged-in':currentUser}"
                           :href="regionRelativeUrl(currentUser ? '/users/account/' : '/users/login/')">
                            <icon-component
                                    :icon="isVipPunter ? vip_user_icon() : fa_user()"
                                    :height="isVipPunter ? '28px':'1em'"
                                    :class="isVipPunter ? 'vip-user':''">
                            </icon-component>
                        </a>
                        <a v-if="showMobileMenu" href="#" @click.prevent="closeMobileMenu()"
                           class="user-dropdown-close">
                            <icon-component viewBox="-55 75 512 512" :icon="fa_times()"></icon-component>
                        </a>
                    </div>

                    <template v-if="isUserAdmin">
                        <a class="btn px-0 user-dropdown-button"
                           :href="regionRelativeUrl('/admin/users')">
                            <icon-component
                                :icon="fa_crown()"
                                :height="'1em'">
                            </icon-component>
                        </a>
                    </template>

                </div>
            </div>
        </div>

        <!-- black navigation-->
        <div class="header-navigation-wrap" v-if="regionData">
            <div class="container">
                <nav class="header-navigation">
                    <a v-for="link in lodash.get(regionData,'navBarLinks',[])" :href="regionRelativeUrl(link.path)">{{ link.title }}</a>
                </nav>
            </div>
        </div>

        <div id="mobileMenu" v-if="regionData">
            <nav class="mobile-navigation mb-4">
                <a v-for="link in lodash.get(regionData,'navBarLinks',[])"
                   :href="regionRelativeUrl(link.path)">{{ link.title }}
                </a>
            </nav>


            <div class="d-flex justify-content-center">
                <a class="btn btn-secondary mt-2" :href="regionRelativeUrl(currentUser ? '/users/account/' : '/users/login/')">
                    {{ translate.account.myAccount }} <icon-component class="ml-3" :icon="fa_user()"></icon-component>
                </a>
            </div>

            <div class="d-flex justify-content-center" v-if="currentUser">
                <a :href="regionRelativeUrl('/users/logout/')" class="btn btn-with-icon btn-logout">
                    {{ translate.login.logout }} <icon-component :icon="fa_sign_out_alt()"></icon-component>
                </a>
            </div>

            <div class="d-flex justify-content-center mt-4">
                <region-selector-component class="w-50"></region-selector-component>
            </div>

        </div>

    </div>

</template>

<script>

import userNotificationMixin from "@/components/mixins/userNotificationMixin";
import userMixin from "@/components/mixins/userMixin";
import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import LanguageSelectionComponent from "@/components/partials/LanguageSelectionComponent.vue";
import IconComponent from "@/components/global/IconComponent.vue";
import {fa_comments_alt, fa_sign_out_alt, fa_times, fa_user, vip_user_icon, fa_crown} from "@/core/constants/icons";
import RegionSelectorComponent from "@/components/partials/RegionSelectorComponent.vue";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";

const data = () => {
    return {
        lodash: _,
        showMobileMenu: false,
        itr: false,
        peppr: false,
    }
};

function toggleMobileMenu() {
    this.showMobileMenu = !this.showMobileMenu;
}

function closeMobileMenu() {
    this.showMobileMenu = false;
}

function trackUpgradeClick(action) {
    this.captureTrackingEvent(this.currentUser, 'profile_administration', action, 'click');
}

export default {
    data,
    beforeDestroy: () => {
        this.destroyPeriodicalUserNotificationSyncer();
    },
    created() {
        if (typeof itrCookie !== 'undefined') {
            this.itr = true;
        }
        if (typeof pepprCookie !== 'undefined') {
            this.peppr = true;
        }
    },
    methods: {
        vip_user_icon,
        fa_crown,
        fa_comments_alt,
        fa_sign_out_alt,
        fa_times,
        fa_user,
        toggleMobileMenu,
        closeMobileMenu,
        trackUpgradeClick,
    },
    watch: {
        // app ready should be called only once the user object is available
        appIsReady: {
            immediate: true,
            handler(value) {
                if (typeof window === 'undefined') {
                    // in case, if it's SSR,
                    // we don't want to execute any of these methods
                    // because they set the JS intervals
                    // and that can cause node.js timeouts
                    return;
                }

                if (value && this.currentUser) {
                    this.periodicallySyncUserNotifications();
                } else {
                    this.destroyPeriodicalUserNotificationSyncer();
                }
            }
        },
    },
    computed: {
        ...mapState(['currentUser', 'translate', 'appIsReady', 'conversationUnreadMessageCount', 'regionData']),
    },
    mixins: [userNotificationMixin, userMixin, xtrackingMixin, regionsUrlMixin],
    components: {
        RegionSelectorComponent,
        IconComponent,
        'language-selection': LanguageSelectionComponent,
    }
}
</script>

